module.exports = __webpack_public_path__ + "assets/img/2539b65.bc89e30d.svg";